import { observable } from "mobx";
import { Type } from "class-transformer";
import VehicleResponse from "./refundVehicleResponse";

// TODO: Generator 1.5 smaze pouzivane atributy
// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RefundChargeResponse {
  @observable
  chargeId?: string;

  @observable
  chargeOrderId?: string;

  @observable
  chargeTypeId!: string;

  /**
   * Price list item Id.
   */
  @observable
  priceListItemId!: string;

  @observable
  @Type(() => VehicleResponse)
  vehicle!: VehicleResponse;

  @observable
  @Type(() => Date)
  validSince!: Date;

  @observable
  @Type(() => Date)
  validUntil!: Date;

  @observable
  price!: number;

  @observable
  officialRecordId?: string;
}
